import React, { useState } from "react";
import "../scss/ViewMoreLess.scss";

const ViewMoreLess = ({ text, truncateLength=30, customClassName}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleView = (e) => {
    e.preventDefault(); // Prevent default link behavior
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      {text ? (
        <>
          <p className={customClassName? customClassName: "view-more-less-text"}>
            {isExpanded
              ? text
              : text.slice(0, truncateLength) +
                (text.length > truncateLength ? "..." : "")}
          </p>
          {text.length > truncateLength && (
            <a
              href="#"
              onClick={toggleView}
              className="view-more-less-text-link"
            >
              {isExpanded ? "View Less" : "View More"}
            </a>
          )}
        </>
      ) : (
        "-"
      )}
    </div>
  );
};

export default ViewMoreLess;
